import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from '@/environments/environment';
import { SpdfGenerationRequest, SpdfGenerationSessionResponse } from '@/app/interfaces/report-spdf';
import { LoaderService } from '@/app/services/interceptor/loader-service';
import { ToastService } from '../script/toast.service';

@Injectable({
  providedIn: 'root',
})
export class SpdfService {
  private readonly generationSessionsEndpoint = `${(environment as { spdfBaseUrl: string }).spdfBaseUrl}/api/v1/generation-sessions`;

  constructor(
    private toastService: ToastService,
    private loader: LoaderService
  ) {}

  async createGenerationSession(
    applicationId: string,
    payload: SpdfGenerationRequest
  ): Promise<SpdfGenerationSessionResponse> {
    if (applicationId !== payload.applicationId) {
      const error = new Error('El applicationId de SPDF no coincide con el payload recibido');

      this.toastService.showError('Error al crear la sesion de generacion SPDF', error.message);
      throw error;
    }

    try {
      this.loader.show();

      const { data } = await axios.post<SpdfGenerationSessionResponse>(
        `${this.generationSessionsEndpoint}?applicationId=${encodeURIComponent(applicationId)}`,
        payload
      );

      return data;
    } catch (error) {
      const errorMessage = (error as { response?: { data?: { message?: string } } }).response?.data?.message;

      this.toastService.showError(
        'Error al crear la sesion de generacion SPDF',
        errorMessage || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }

  async getPdf(generationId: string, applicationId: string): Promise<Blob> {
    try {
      this.loader.show();

      const { data } = await axios.get<Blob>(
        `${this.generationSessionsEndpoint}/${encodeURIComponent(generationId)}/pdf?applicationId=${encodeURIComponent(applicationId)}`,
        {
          responseType: 'blob',
        }
      );

      return data;
    } catch (error) {
      const errorMessage = (error as { response?: { data?: { message?: string } } }).response?.data?.message;

      this.toastService.showError(
        'Error al recuperar el documento generado en SPDF',
        errorMessage || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }
}
